import { createPortal } from 'react-dom'
import { Shield } from 'lucide-react'
import { useEffect, useState } from 'react'

interface RGPDButtonProps {
  onClick: () => void
}

export default function RGPDButton({ onClick }: RGPDButtonProps) {
  const [isCookieBannerVisible, setIsCookieBannerVisible] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    
    // Verificar si el banner de cookies está visible
    const checkCookieBanner = () => {
      const cookieConsent = localStorage.getItem('cookieConsent')
      setIsCookieBannerVisible(!cookieConsent)
    }

    checkCookieBanner()
    
    // Escuchar cambios en localStorage
    window.addEventListener('storage', checkCookieBanner)
    
    // También verificar periódicamente
    const interval = setInterval(checkCookieBanner, 1000)

    return () => {
      window.removeEventListener('storage', checkCookieBanner)
      clearInterval(interval)
    }
  }, [])

  const handleClick = () => {
    console.log('🔵 🔵 🔵 RGPD BUTTON DEFINITELY CLICKED 🔵 🔵 🔵')
    onClick()
  }

  if (!mounted) return null

  // Ajustar posición si el banner de cookies está visible
  const bottomPosition = isCookieBannerVisible ? 'bottom-32' : 'bottom-6'

  const button = (
    <button
      onClick={handleClick}
      onMouseDown={(e) => {
        console.log('🟡 Mouse down on RGPD button')
        e.stopPropagation()
      }}
      onMouseUp={(e) => {
        console.log('🟡 Mouse up on RGPD button')
        e.stopPropagation()
      }}
      className={`fixed ${bottomPosition} right-6 z-[9999] w-14 h-14 bg-education text-white rounded-full shadow-2xl hover:shadow-3xl hover:scale-110 transition-all flex items-center justify-center group cursor-pointer`}
      aria-label="Abrir centro de privacidad RGPD"
      type="button"
      id="rgpd-button-main"
      data-testid="rgpd-button"
      style={{
        boxShadow: '0 10px 40px rgba(37, 99, 235, 0.4)',
        backdropFilter: 'blur(10px)',
        pointerEvents: 'auto'
      }}
    >
      <Shield className="w-7 h-7 pointer-events-none" />
      <span className="absolute right-16 bg-gray-900 text-white text-xs font-semibold px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Privacidad RGPD
      </span>
    </button>
  )

  // Renderizar usando portal directamente en body
  return createPortal(button, document.body)
}